import { createFileRoute } from "@tanstack/react-router";
import { AdminStaffUsersPage } from "@/components/admin/pages/AdminStaffUsersPage";

export const Route = createFileRoute("/pulse-ops-x7k2/admin-users")({
  component: AdminStaffUsersPage,
});
